import { useState } from "react";
import { PenLine, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, dataIt, formatError } from "@/lib/api";
import { FirmaDialog } from "@/components/FirmaDialog";

export const FirmaImg = ({ firma, data, testId }) => (
  <div className="flex h-16 items-end">
    {firma && <img src={firma} alt="Firma" className="max-h-16 max-w-full object-contain" data-testid={testId} />}
    {firma && data && <span className="ml-2 text-[9px] text-slate-400">firmato il {dataIt(data.slice(0, 10))}</span>}
  </div>
);

export const FirmaCliente = ({ label, endpoint, doc, onSaved, prefix, readOnly }) => {
  const [open, setOpen] = useState(false);
  const salva = async (firma) => {
    try {
      await api.post(endpoint, { firma });
      toast.success(firma ? "Firma salvata" : "Firma rimossa");
      onSaved();
    } catch (e) {
      toast.error(formatError(e));
      throw e;
    }
  };
  return (
    <div>
      <FirmaImg firma={doc.firma_cliente} data={doc.firma_data} testId={`${prefix}-firma-img`} />
      <div className="border-t border-slate-400 pt-1">{label}</div>
      {!readOnly && <div className="mt-2 flex gap-2 print:hidden">
        <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={`${prefix}-firma-button`}>
          <PenLine className="mr-1 h-3.5 w-3.5" /> {doc.firma_cliente ? "Rifai firma" : "Firma su schermo"}
        </Button>
        {doc.firma_cliente && (
          <Button size="sm" variant="ghost" className="text-slate-500" onClick={() => salva("")} data-testid={`${prefix}-firma-rimuovi`}><Trash2 className="h-3.5 w-3.5" /></Button>
        )}
      </div>}
      {!readOnly && <FirmaDialog open={open} onOpenChange={setOpen} title="Firma del cliente" onSave={salva} />}
    </div>
  );
};
